import { openobserveRum } from '@openobserve/browser-rum';
import { openobserveLogs } from '@openobserve/browser-logs';

/**
 * Initializes OpenObserve RUM (Real User Monitoring) and Logs instrumentation.
 *
 * This is purely additive observability wiring: it must never throw, never block
 * app render, and must no-op entirely when the client token is not configured
 * (e.g. local dev without the env var set, or any build where the org secret
 * hasn't been injected).
 */
export function initRum() {
    // OPENOBSERVE_CLIENT_TOKEN is a public, write-only RUM token injected at build time.
    const clientToken = process.env.REACT_APP_OPENOBSERVE_CLIENT_TOKEN;

    if (!clientToken) return;
    if (typeof window === 'undefined') return;

    try {
        const sameOriginOrIncruiterHost = (options) => {
            try {
                const url = new URL(options.url, window.location.origin);
                return url.origin === window.location.origin || /\.incruiter\.com$/.test(url.hostname);
            } catch (e) {
                return false;
            }
        };

        const sharedConfig = {
            applicationId: 'frontend-incbot',
            service: 'frontend-incbot',
            clientToken,
            site: 'monitor.incruiter.com',
            organizationIdentifier: 'default',
            env: 'development',
            version: '0.0.1',
            insecureHTTP: false,
            apiVersion: 'v1',
        };

        openobserveRum.init({
            ...sharedConfig,
            trackResources: true,
            trackLongTasks: true,
            trackUserInteractions: true,
            sessionSampleRate: 100,
            sessionReplaySampleRate: 20,
            defaultPrivacyLevel: 'mask',
            allowedTracingUrls: [
                {
                    match: sameOriginOrIncruiterHost,
                    propagatorTypes: ['tracecontext', 'openobserve'],
                },
            ],
        });

        openobserveRum.startSessionReplayRecording();

        openobserveLogs.init({
            ...sharedConfig,
            forwardErrorsToLogs: true,
        });
    } catch (error) {
        console.warn('[OpenObserve RUM] Failed to initialize', error);
    }
}
